






































































































































import { StoreActions, StoreMutations } from '@/store';
import { Component, Provide, Vue } from 'vue-property-decorator';
import Field from '@/components/form/Field.vue';
import { required, email } from 'vuelidate/lib/validators';
import { Family, newFamily } from '@/model/family.model';

@Component({
  components: {
    Field,
  },
  validations: {
    family: {
      name: {
        required,
      },
      street: {},
      number: {},
      code: {},
      place: {},
      members: {
        $each: {
          first: { required },
          last: { required },
          birth: {},
        },
      },
      contacts: {
        $each: {
          name: {},
          email: { email },
          phone: {},
          newsletter: {},
        },
      },
    },
  },
})
export default class FamilyEdit extends Vue {
  @Provide() family: Family = { ...newFamily };

  submitting: boolean = false;

  get fam() {
    return this.$store.state.family;
  }

  mounted() {
    if (this.$route.params.key) {
      this.$store.dispatch(StoreActions.GetFamily, this.$route.params.key);
    } else {
      this.$store.commit(StoreMutations.NewFamily);
    }
    this.family = { ...this.fam };
  }

  destroyed() {
    this.$store.commit(StoreMutations.SetFamily, null);
  }

  addMember() {
    this.family.members = [
      ...this.family.members,
      { first: '', last: '', birth: '' },
    ];
  }

  removeMember(index: number) {
    this.family.members.splice(index, 1);
  }

  addContact() {
    this.family.contacts = [
      ...this.family.contacts,
      { name: '', email: '', phone: '', newsletter: true },
    ];
  }

  removeContact(index: number) {
    this.family.contacts.splice(index, 1);
  }

  cancel() {
    this.$router.push(`/family/${this.$route.params.key}`);
  }

  async submit() {
    if (!this.$v.$invalid) {
      this.submitting = true;
      await this.$store.dispatch(StoreActions.SaveFamily, this.family);
      this.cancel();
      this.submitting = false;
    }
  }

  async remove() {
    if (confirm('Are you sure you want to remove this family')) {
      await this.$store.dispatch(StoreActions.DeleteFamily, this.family);
      this.$router.push(`/family`);
    }
  }
}
